export const datePlusDays = (days) => {
  let date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

export const datePlusMonths = (months) => {
  let date = new Date();
  date.setMonth(date.getMonth() + months);
  return date;
};

export const isSameDay = (date1, date2) => {
  return (
    date1?.getFullYear() === date2?.getFullYear() &&
    date1?.getMonth() === date2?.getMonth() &&
    date1?.getDate() === date2?.getDate()
  );
};

export const parseDay = (timestamp) => {
  let today = new Date(),
    yesterday = new Date(Date.now() - 86400000),
    stamp = new Date(timestamp);

  if (isSameDay(stamp, today)) return "Today";
  if (isSameDay(stamp, yesterday)) return "Yesterday";
  return dateParser(timestamp, "day");
};

export const dateParser = (inDate, type) => {
  let date = !inDate ? new Date() : typeof inDate === "object" ? inDate : new Date(inDate),
    m = date.getMonth(),
    mm = m < 9 ? `0${m + 1}` : m + 1,
    month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][m],
    day = date.getDate(),
    dd = day < 10 ? `0${day}` : day,
    weekDay = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"][date.getDay()],
    year = date.getFullYear(),
    h = date.getHours(),
    minute = `0${date.getMinutes()}`.slice(-2),
    period = h > 11 ? "PM" : "AM",
    hr = h > 11 ? h - 12 : h,
    hour = hr === 0 ? 12 : hr,
    str;

  switch (type) {
    case "mmm dd":
      str = `${month} ${day}`;
      break;
    case "yyyy-mm-dd":
      str = `${year}-${mm}-${dd}`;
      break;
    case "date":
      str = `${month} ${day}, ${weekDay}`;
      break;
    case "mmm dd, yyyy":
    case "day":
      str = `${month} ${day}, ${year}`;
      break;
    case "time":
      str = `${hour}:${minute} ${period}`;
      break;
    case "day-time":
      str = `${parseDay(date)}, ${hour}:${minute} ${period}`;
      break;
    case "day-at-time":
      str = `${parseDay(date)} at ${hour}:${minute} ${period}`;
      break;
    default:
      str = `${month} ${day}, ${year}, ${hour}:${minute} ${period}`;
  }

  return str;
};

export default dateParser;
